import React, { useEffect, useState, useContext } from 'react';
import InfoIcon from '@material-ui/icons/Info';
import Menu from '@material-ui/core/Menu';
import { symptomCodes } from '@mummssoftware/utils';
import {
  FlexRow,
  SIATitleDiv,
  CodeDiv,
  CodeTextDiv,
  TooltipDiv,
  CodeListDiv,
} from './HOPEWrappers';
import defaults from '../../translations/en.json';

export const CodeTooltip = () => {
  const [tooltipAnchorEl, setTooltipAnchorEl] = useState<any | null>(null);
  const codes = Object.entries(symptomCodes);
  return (
    <>
      <InfoIcon
        onClick={(event: any) => setTooltipAnchorEl(event.currentTarget)}
      />
      <Menu
        anchorEl={tooltipAnchorEl}
        open={!!tooltipAnchorEl}
        onClose={() => setTooltipAnchorEl(null)}
      >
        <TooltipDiv>
          <SIATitleDiv>{`${defaults.responseCode}:`}</SIATitleDiv>
          <CodeListDiv>
            {codes.map((code: any) => (
              <div key={code[0]}>
                <FlexRow>
                  <CodeDiv>{`${code[0]}.`}</CodeDiv>
                  <CodeTextDiv>{code[1]}</CodeTextDiv>
                </FlexRow>
              </div>
            ))}
          </CodeListDiv>
        </TooltipDiv>
      </Menu>
    </>
  );
};
